// extracted by mini-css-extract-plugin
module.exports = {"underline":"az_lT","nextUnderline":"az_mT","center":"az_nT","inlineheader":"az_oT","centerInline":"az_pT","inlineH2orH3":"az_qT","firstText":"az_rT"};